
import { Vue, Component } from "vue-property-decorator";
import { backToBefore, LoginReturnDataDto, backHomes } from "@/utils/h5ToApp";
import {
  getVersionCodeList,
  partnerCompanyDto,
  modifyBindingVersionCode,
  getCompanyInfoByPartner,
  getCompareCode,
  bindingVersionCode,
} from "@/api/company";
import { Getter } from "vuex-class";

@Component({
  components: {},
})
export default class Version extends Vue {
  @Getter info!: LoginReturnDataDto;

  partnerCompanyList: partnerCompanyDto[] = [];

  show = false;
  versionCode = "";

  created() {
    // this.$store.dispatch('GetInfo').then(res => {
    this.getVersionCodeList();
    // })
  }

  handleBack() {
    this.$router.back();
    // backToBefore()
  }

  // input输入限制（英文、数字）独立编码
  formatterInput(value) {
    return value.replace(/[^a-zA-Z\d]/g, "").toUpperCase(); // 大写英文和数字
  }

  bindingVersionCode() {
    if (this.$checkIsEmpty(this.versionCode)) {
      this.$toast("请输入版本邀请码");
      return false;
    }
    // 匹配邀请码 判断填写的邀请码是否有效
    getCompareCode({ versionCode: this.versionCode })
      .then((res) => {
        let params = {
          type: "2", // 邀请码or版本码
          versionCode: this.versionCode,
        };
        // 绑定邀请码
        bindingVersionCode(params)
          .then((res) => {
            this.show = false;
            this.$toast.success({
              message: `绑定成功`,
              duration: 1000,
              onClose: () => {
                this.enterVersion(res.data);
              },
            });
          })
          .catch((err) => {
            this.$toast(err.data.msg);
          });
      })
      .catch((err) => {
        this.$toast(err.data.msg);
      });
  }

  getIsCurrent(code: any) {
    if (!code && this.info.currentVersionCode === "system") {
      return true;
    } else if (code === this.info.currentVersionCode) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 获取版本列表
   */
  getVersionCodeList() {
    getVersionCodeList({}).then((res) => {
      this.partnerCompanyList = res.data.partnerCompanyList;
    });
  }

  addVersion() {
    // this.$router.push({
    //     path: '/addVersionCode',
    //     query: {
    //         formPage: 'h5'
    //     }
    // })
    this.show = true;
  }

  // 切换版本
  enterVersion(version: partnerCompanyDto) {
    this.$confirmDialog.show({
      okText: "确认切换",
      cancelText: "取消",
      tips: `公司名下所有子账号全部将切换至${version.companyShortName}版本，是否确认切换？`,
      onOk: () => {
        return this.modifyBindingVersionCode(version);
      },
      onCancel: () => {
        this.getVersionCodeList();
      },
    });
  }

  modifyBindingVersionCode(version: partnerCompanyDto) {
    let parma = {
      versionCode: version.versionCode,
    };
    modifyBindingVersionCode(parma).then((res) => {
      getCompanyInfoByPartner({
        partnerCompanyId: res.data.partnerCompanyId,
      }).then((data) => {
        let parmas = {
          partnerLogoUrl: data.data.logoUrl || "", // 合作方Logo
          partnerCompanyId: data.data.companyId || "system", // 合作方Id
          partnerCompanyName: data.data.companyName || "南瓜头APP", // 合作方名称
          currentVersionCode: version.versionCode || "system", // 版本号
          partnerCompanyShortName: data.data.companyShortName || "南瓜头", // 合作方简称
        };
        console.log("调用原生updateuserInfo方法");
        console.log(parmas);
        this.$bridge.callHandler("updateUserInfo", parmas, () => {
          // 调用原生方法返回首页
          backHomes();
        });
      });
    });
  }
}
